import moment from 'moment';
import Vue from 'vue';
import VueRouter from 'vue-router';
import Falcon from '@superpitch/falcon';
import Clipboard2 from 'vue-clipboard2';
import App from './App.vue';
import { i18n } from './lang';
import { ROUTER as router } from './routes';
import './assets/styles/vendors.scss';
import './assets/styles/main.scss';

// Register globally used moment
Object.defineProperty(Vue.prototype, '$moment', { value: moment });

Vue.use(VueRouter);
Vue.use(Falcon);
Vue.use(Clipboard2);
Vue.config.productionTip = false;
// Vue.config.productionTip = true;
new Vue({
    i18n,
    router,
    render: h => h(App),
}).$mount('#app');
